import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/components/AuthShell";
import { formatApiErrorDetail } from "@/lib/api";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/app/home", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full px-4 py-3.5 rounded-2xl bg-[#2A0A1B] border border-[#E32C8C]/35 bw-card text-[#F6DCEA] placeholder:text-[#EAC6D9]/60 focus:outline-none focus:border-[#E32C8C] transition-all";

  return (
    <AuthShell title="Bentornata" subtitle="Accedi per continuare il tuo percorso">
      <form onSubmit={submit} className="space-y-3">
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email" required data-testid="login-email-input" className={inputCls}
        />
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="Password" required data-testid="login-password-input" className={inputCls}
        />
        {error && <p className="text-sm text-[#FF7AB8] text-center" data-testid="login-error">{error}</p>}
        <button
          type="submit" disabled={busy} data-testid="login-submit-btn"
          className="w-full bg-gradient-to-r from-[#E32C8C] to-[#8E1A52] text-white font-semibold py-3.5 px-6 rounded-full shadow-lg shadow-[#E32C8C]/25 bw-glow hover:opacity-95 active:scale-[0.98] transition-all disabled:opacity-60"
        >
          {busy ? "Accesso…" : "Accedi"}
        </button>
      </form>

      <div className="flex items-center gap-3 my-5">
        <div className="flex-1 h-px bg-[#6B2247]" />
        <span className="text-xs text-[#EAC6D9]">oppure</span>
        <div className="flex-1 h-px bg-[#6B2247]" />
      </div>
      <GoogleButton />

      <p className="text-center text-sm text-[#EAC6D9] mt-6">
        Non hai un account?{" "}
        <Link to="/register" data-testid="go-register-link" className="text-[#E32C8C] font-semibold underline">
          Registrati
        </Link>
      </p>
    </AuthShell>
  );
}
